import React, {FC, useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getUserImageGoogle, IDisplayUser} from '../../../common/async/AsyncCalls';
import { removeLocalStorageItem } from '../../../common/helpers/LocalStorage';
import {IUserState} from '../../../common/state/profile/user';
import NavbarUser from '../../../components/navbar/Navbar.user';
// custom

const UserProfileView : FC = () => {
    const backgroundImageURL = `url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80')`;
    // states
    const token: string = useSelector(({user} : {
        user: IUserState
    }) => user.token);
    const userProfile : IDisplayUser = useSelector(({user} : {
        user: IUserState
    }) => user.profile);
    const [imageURL, setImageURL] = useState('');

    //lifecycle
    const fetchUserImage = useCallback(async ()=>{
        if (!token || token === '') return;
        await getUserImageGoogle(token, userProfile?.image);
    },[userProfile, token]);

    useEffect(()=>{
        // bugfix since image doesnt render
        fetchUserImage();
        setImageURL(userProfile.image);
    },[userProfile.image]);
    
    
    // evt handlers
    function handleLogout() {
        removeLocalStorageItem(`token`);
        removeLocalStorageItem(`profile`);
        window.location.href = "/";
      }
      
    return <React.Fragment>
        <NavbarUser/>
        <div
            className="h-screen overflow-y-scroll bg-gray-200 dark:bg-gray-800 flex flex-col
                justify-start items-center text-gray-700 dark:text-gray-300 dartext-base">
            <main className="profile-page">
                <section
                    className="relative block"
                    style={{
                    height: "500px"
                }}>
                    <div
                        className="absolute top-0 w-full h-full bg-center bg-cover"
                        style={{
                        backgroundImage: backgroundImageURL
                    }}>
                        <span id="blackOverlay" className="w-full h-full absolute opacity-50 bg-black"></span>
                    </div>
                    <div
                        className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden"
                        style={{
                        height: "70px"
                    }}>
                        <svg
                            className="absolute bottom-0 overflow-hidden"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0">
                            <polygon className="text-gray-300 fill-current" points="2560 0 2560 100 0 100"></polygon>
                        </svg>
                    </div>
                </section>
                <section className="relative py-16">
                    <div className="container mx-auto px-4">
                        <div
                            className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 
                                shadow-xl rounded-lg -mt-64">
                            <div className="px-6">
                                <div className="flex flex-wrap justify-center">
                                    <div className="w-full px-4 lg:order-2 flex justify-center">
                                        <div className="relative">
                                            {imageURL !== '' && <img
                                                alt="user-profile-image"
                                                src={imageURL}
                                                className="shadow-xl rounded-full h-auto align-middle border-none 
                                                    absolute -m-16 -ml-12 lg:-ml-12"
                                                style={{
                                                maxWidth: "150px"
                                            }}/>}
                                        </div>
                                    </div>
                                    <div className="w-full px-4 lg:order-3 text-center md:text-right">
                                        <div className="px-3 mt-16 lg:mt-4">
                                            <button
                                                onClick={handleLogout}
                                                className="bg-secondary-500 active:bg-secondary-600 uppercase text-white 
                                                    font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none 
                                                    focus:outline-none sm:mr-2 mb-1"
                                                type="button"
                                                style={{
                                                transition: "all .15s ease"
                                            }}>
                                                Sign Out
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mt-12">
                                    <h3
                                        className="text-4xl font-semibold leading-normal mb-2 text-gray-800 mb-2 uppercase">
                                        {userProfile
                                            ?.name ?? ''}
                                    </h3>
                                    <div
                                        className="text-lg leading-normal mt-0 mb-2 text-gray-500 font-bold lowercase">
                                        <i className="fas fa-map-marker-alt mr-2 text-lg text-gray-500"></i>{" "} {userProfile
                                            ?.email ?? ''}
                                    </div>
                                    <div className="mb-2 text-gray-700 mt-10">
                                        <i className="fas fa-briefcase mr-2 text-lg text-gray-500"></i>
                                        Your current role: <strong>{userProfile?.role?.toUpperCase() ?? 'NEW'} User</strong>
                                    </div>
                                    <div className="mb-2 text-gray-700">
                                        <i className="fas fa-university mr-2 text-lg text-gray-500"></i>
                                        SSO Login Vendor: <strong>{userProfile?.vendor?.toUpperCase() ?? 'Google'}</strong>
                                    </div>
                                </div>
                                <div className="mt-10 py-10 border-t border-gray-300 text-center">
                                    <div className="flex flex-wrap justify-center">
                                        <div className="w-full lg:w-9/12 px-4">
                                            <p className="mb-4 text-sm leading-relaxed text-gray-800">
                                                Power Ministries International Inc., USA is certified by the United Nations
                                                Global Compact We support universally accepted 10 principles of UNITED NATIONS
                                                Global Compact & UNITED NATIONS HUMAN RIGHTS & ALL CHARTERS OF UNITED NATIONS
                                            </p>
                                            <a
                                                href="https://www.powerministry.info/#/index" target="_blank" 
                                                rel="noopener noreferrer"
                                                className="font-normal text-pink-500">
                                                Visit Site
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    </React.Fragment>
};

export default UserProfileView;